module.exports = __webpack_public_path__ + "static/room--garage.0c84b007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/room--garage.png
// module id = 34
// module chunks = 8482045208941 35783957827783 105603797122985 114276838955818 126609682503911 164485488089077 252234152318474